import { CommunicationRequest as Communication } from '../../../business/models/dto/rim/communication.request.dto';
import { CounterExpertiseRequest as CounterExpertise } from '../../../business/models/dto/rim/counter-expertise.request.dto';
import { ValueAndCauseRequest as ValueAndCause } from '../../../business/models/dto/rim/value-and-cause.request.dto';
import { VatAndPaymentRequest as VatAndPayment } from '../../../business/models/dto/rim/vat-and-payment.request.dto';
import { SigningRequest as Signing } from '../../../business/models/dto/rim/signing.request.dto';
import { RemarkRequest as RemarkType } from '../../../business/models/dto/rim/remark.request.dto';
import { RimReportRequest } from '../../../business/models/dto/rim/rim-report.request.dto';
import { RimLinesRequest as RimLine } from '../../../business/models/dto/rim/rim-lines.request.dto';

import api from './api';

const rimUrl = '/rims';

export function getRimsTotal(instructionId: number) {
  return api.get(`${rimUrl}/list/${instructionId}`);
}

export function getRimTypeCodes() {
  return api.get(`${rimUrl}/typecodes`);
}

export function getRim(rimHeaderId: number) {
  return api.get(`${rimUrl}/${rimHeaderId}`);
}

export function saveValueAndCause(rimId: number, instructionId: number, data: ValueAndCause) {
  return api.post(`${rimUrl}/value-and-cause`, {
    id: rimId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveVatAndPayment(rimId: number, instructionId: number, data: VatAndPayment) {
  return api.post(`${rimUrl}/vat-and-payment`, {
    id: rimId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveCounterExpertise(rimId: number,  instructionId: number, data: CounterExpertise) {
  return api.post(`${rimUrl}/counter-expertise`, {
    id: rimId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveCommunication(rimId: number,  instructionId: number, data: Communication) {
  return api.post(`${rimUrl}/communication`, {
    id: rimId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveRemark(rimId: number,  instructionId: number, data: RemarkType) {
  return api.post(`${rimUrl}/remark`, {
    id: rimId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveRimLines(rimId: number,  instructionId: number, data: RimLine[], vat6ToBeJustifiedAmount: number, vat21ToBeJustifiedAmount: number) {
  return api.post(`${rimUrl}/rim-lines`, {
    id: rimId,
    instructionId: instructionId,
    data: data,
    vat6ToBeJustifiedAmount: vat6ToBeJustifiedAmount,
    vat21ToBeJustifiedAmount: vat21ToBeJustifiedAmount
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveSigning(rimId: number, instructionId: number, data: Signing, locked: boolean) {
  return api.post(`${rimUrl}/signing`, {
    id: rimId,
    instructionId: instructionId,
    data: data,
    locked: locked
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function setStatus(rimId: number, status: string) {
  return api.post(`${rimUrl}/status`, {
    id: rimId,
    status: status
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function generateReports(request: RimReportRequest) {
  return api.post(`${rimUrl}/generate-reports`, request).catch(err => {
    console.error(err);
    return err;
  });
}
